import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Routes } from './routes'

const Navigation = () => (
	<Router>
		<Routes />
	</Router>
)

export default Navigation
